<template>
  <vue-d3 :onExportPng="handleExportPng" :showExport="showExport">
    <div ref="vis-ref"></div>
  </vue-d3>
</template>

<script>
import { Beeswarm } from './Beeswarm';
import VueD3 from '../VueD3.vue';

export default {
  name: 'BeeswarmWrapper',
  components: {
    VueD3,
  },
  props: {
    width: Number,
    height: Number,
    exportTitle: String,
    exportFileName: String,
    markRadius: Number,
    min: Number,
    max: Number,
    showExport: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      required: true,
    },
    focalId: {
      type: String,
    },
    color: {
      type: Function,
    },
    valueAccessor: {
      type: Function,
    },
    nodeTooltip: {
      type: Function,
    },
    onNodeClick: {
      type: Function,
    },
  },
  data() {
    return {
      chartInstance: null,
    };
  },
  mounted() {
    this.chartInstance = new Beeswarm({
      target: this.$refs['vis-ref'],
      data: this.data,
      exportFileName: this.exportFileName,
      exportTitle: this.exportTitle,
      width: this.width,
      height: this.height,
      focalId: this.focalId,
      color: this.color,
      valueAccessor: this.valueAccessor,
      markRadius: this.markRadius,
      min: this.min,
      max: this.max,
      nodeTooltip: this.nodeTooltip,
      onNodeClick: this.onNodeClick,
    });
    this.$emit('init', this.chartInstance);
  },
  watch: {
    focalId(newValue, oldValue) {
      if (this.chartInstance) {
        this.chartInstance.focus(newValue);
      }
    },
  },
  methods: {
    handleExportPng() {
      if (this.chartInstance) {
        this.chartInstance.exportToPng();
      }
    },
  },
};
</script>
